import { createContext, useContext } from "react";

import { Search } from "@/types/Search";

type AlertContextType = {
  alerts: Search[] | null;
  patchAlert: (uuid: string, search: Partial<Search>) => void;
  refresh: () => Promise<void>;
  groupedAlerts: {
    active: Search[];
    inactive: Search[];
    saved: Search[];
  };
};

const AlertContext = createContext<AlertContextType>({} as AlertContextType);

export default AlertContext;

export const useAlert = () => useContext(AlertContext);
